import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export const fetchDonationTypeApi = async (url: string): Promise<any> => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/DonationType/GetDonationType`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const addDonationTypeApi = async (url: string, name: string) => {
  const token = cookies.get("authToken");
  const data = {
    url: url,
    Name : name
  }

  try {
    const response = await axios.post(
      `${url}/DonationType/addDonationType`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
};

export const addSubTypeApi = async (
  url: string,
  parentId: string,
  name: string
) => {
  const token = cookies.get("authToken");
  const data = {
    url: url,
    ParentId: parentId,
    Name: name,
  };

  try {
    const response = await axios.post(
      `${url}/DonationType/addsubtype`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
};

export const fetchDonationTypeChildApi = async (
  url: string,
  parentId: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(
      `${url}/DonationType/GetDonationTypeChild`,
      {
        params: { parentId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const deleteDonationType = async (url: string, id: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.request({
      method: "DELETE",
      url: `${url}/DonationType/delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting taxonomy:", error);
    throw error;
  }
};

export const deleteChildDonationType = async (url: string, id: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.request({
      method: "DELETE",
      url: `${url}/DonationType/deletesubtype`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting taxonomy:", error);
    throw error;
  }
};

export const updateDonationTypeChildApi = async (
  url: string,
  id: string,
  parentId: string,
  name: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/DonationType/updateDonationTypeChild`,
      {
        Id: id,
        ParentId: parentId,
        Name: name,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateDonationTypeApi = async (
  url: string,
  id: string,
  name: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/DonationType/update`,
      {
        Id: id,
        Name: name,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
